module.exports = __webpack_public_path__ + "static/img/qualifications2.e8a59e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qualifications2.png
// module id = 0Q+k
// module chunks = 1